export default __webpack_public_path__ + "static/media/amount-icon.dd70d9a1.svg";